import qsa from '../../scripts/util/DOM/qsa';
import qs from '../../scripts/util/DOM/qs';
import bindEvent from '../../scripts/util/bindEvent';
import addClass from '../../scripts/util/DOM/addClass';
import {forEach} from 'ramda';
import $ from 'jquery';
import 'malihu-custom-scrollbar-plugin';

const selectors = {
	tab: '.tab__item',
	tabActive: '.tab__item_active',
	default: '#all',
	list: '.tab',
	supportContent: '.support__content'
};

const refs = {
	tab: qs(selectors.tab),
	content: qs(selectors.default)
};

const classes = {
	animate: 'support__content_animate',
	show: 'support__content_show',
	active: 'tab__item_active',
	disabled: 'tab__item_disabled'
};

const scrollSettings = {
	theme: 'custom',
	scrollInertia: 0,
	axis: 'x'
};

const $scroller = $(selectors.list);

export const clearPrevs = () => {
	$(selectors.supportContent).removeClass(classes.show).removeClass(classes.animate);
	$(selectors.tabActive).removeClass(classes.active);
};

const setActiveTab = tab => {
	addClass(classes.active)(tab);
	refs.tab = tab;
};

export const setDefaultTab = () => {
	refs.tab.classList.remove(classes.active);
	const tab = qs(selectors.tab);
	setActiveTab(tab);
};

const scroll = id => {
	$('html, body').animate({
		scrollTop: $(id).offset().top - 300
	}, 500);
};

const showContent = () => {
	const hash = window.location.hash;
	const id = hash === '' ? selectors.default : hash;

	if (id !== hash) {
		setDefaultTab();
	}

	const block = qs(id);
	// console.log(block);
	addClass(classes.animate)(block);

	setTimeout(() => {
		addClass(classes.show)(block);
	}, 100);

	scroll(id);

	refs.content = block;

};
const isOpen = elem => {
	return 	elem.classList.contains(classes.active);
};

const open = e => {
	const tab = e.currentTarget;
	const category = $(tab).data('item-category');
	e.preventDefault();
	clearPrevs();

	if (!isOpen(tab)) {
		$(tab).addClass(classes.active);
		$('section[data-category=' + category + ']').addClass(classes.animate).addClass(classes.show);
	}
};

const setCount = number => e => {
	if (number === 0) {
		addClass(classes.disabled)(e);
	}
	e.querySelector('span').innerHTML = `(${number})`;

};

export const count = number => {
	forEach(setCount(number), qsa(selectors.tab));
};

export const renderTab = () => {
	showContent();
	$scroller.mCustomScrollbar(scrollSettings);
	bindEvent(selectors.tab, 'click', open);
};
